import { HttpHelper, HttpServiceParams } from 'rbh-merchant-core';
import { GENERAL_REQUEST_ID_LIST } from './general-constant';

class GeneralServiceClass {
  getTnc = async (params: HttpServiceParams) => {
    return await HttpHelper.get({
      url: 'v1/merchant/company-admin/tnc/latest',
      id: GENERAL_REQUEST_ID_LIST.GET_TNC
    });
  }

  getHtmlTncLogisticHandler = async (params: HttpServiceParams) => {
    return await HttpHelper.get({
      url: params.data,
      id: GENERAL_REQUEST_ID_LIST.GET_TNC_HTML
    });
  }

  postTnc = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: 'v2/merchant/company-admin/tnc',
      id: GENERAL_REQUEST_ID_LIST.POST_TNC,
      data: params.data,
    });
  }

  postWebLog = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: 'v1/merchant/company-admin/fe-log',
      id: GENERAL_REQUEST_ID_LIST.POST_WEB_LOG,
      data: params.data,
    });
  }

  getGeneralConfigs = async () => {
    return await HttpHelper.get({
      url: 'v1/merchant/master/general-configs',
      id: GENERAL_REQUEST_ID_LIST.GET_GENERAL_CONFIG
    });
  }
}

export const GeneralService = new GeneralServiceClass();
